import React from "react";
// import BlockContent from '@sanity/block-content-to-react';
import style from "./guide.module.css";
import { handleDate } from "utils/handleDate";
function Card({
  image,
  title,
  subtitle,
  width,
  height,
  date,
  lang,
}: {
  image: string;
  title: string;
  subtitle: string;
  width?: number;
  height?: number;
  date?: any;
  lang?: any;
}) {
  return (
    <div className={style.cardCon}>
      {image && (
        <div className={style.cardImg}>
          <img src={image} alt={image} width={"100%"} height={"100%"} />
          {date ? (
            <span dir={lang === "ar" ? "rtl" : "ltr"}>{`${handleDate(
              date,
              lang
            )}`}</span>
          ) : null}
        </div>
      )}
      <div className={style.cardContent}>
        <span className={style.title}>{title}</span>
        <p className={style.subtitle}>{subtitle}</p>
      </div>
    </div>
  );
}

export default Card;
